import React from 'react';
import { PropTypes } from 'prop-types';
import { TiWarningOutline } from 'react-icons/ti';

import { BaIconLink } from 'components/ui/icons';
import ShareButton from 'components/ui/share';
import Button from 'components/ui/button';
import MagicLink from 'components/ui/magic-link';
import { supportNativeShare } from 'components/utils/device';
import CardCreateSubsectionHeader from 'components/card-send-create/card-create-subsection-header';

import { useApp } from 'hooks/app';

import './styles.scss';

const CardCreateSignerLink = ({
  cardSend,
  onFinish
}) => {
  const { showAlert } = useApp();

  const { groupInviteLink, draftInd } = cardSend;

  return (
    <div className="card-create-signer-link-container">
      <CardCreateSubsectionHeader
        Icon={BaIconLink}
        title="SHARE A LINK"
        onBack={onFinish}
      />
      <div className="card-create-signer-link-contents">
        <h3 className="card-create-signer-link-title">Invite signers by sharing a link:</h3>
        {supportNativeShare ?
          <ShareButton
            url={groupInviteLink}
            title="Sign this group card"
            dialogTitle="Invite Signers by Link"
            buttonTitle="Copy Invite Link"
            onError={() => showAlert({ message: 'There was an error trying to share', type: 'error' })}
          >
            <Button onClick={() => {}}>SHARE NOW</Button>
          </ShareButton>
        :
          <MagicLink
            link={groupInviteLink}
            buttonProps={{
              color: 'white',
              sx: { height: 56, padding: '0.7em', marginLeft: '-3px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderTopRightRadius: 4, borderBottomRightRadius: 4, color: '#17a17e', border: '1px solid #d3d3d3' }
            }}
            buttonTitle="Copy"
            // marketingId={magicLinkMarketingId}
            className="magic-link"
          />
        }
        {draftInd === 1 &&
          <div className="draft-mode-info">
            <div className="draft-mode-header">
              <TiWarningOutline className="warning-icon"/>
              <span>DRAFT MODE</span>
            </div>
            <p className="draft-mode-text">Sharing this link in draft mode will allow people to add their messages but they will not be able to see messages from other signers until the card is completed.</p>
          </div>
        }
      </div>
    </div>
  )
}

CardCreateSignerLink.propTypes = {
  cardSend: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired
};

CardCreateSignerLink.defaultProps = {

};

export default CardCreateSignerLink;